module.exports = __webpack_public_path__ + "static/img/ty2.f595aae.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/ty2.png
// module id = 14JA
// module chunks = 1